import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks, site } from '../data/site';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-200 ease-smooth ${scrolled || open ? 'bg-forest-900/95 shadow-nav backdrop-blur' : 'bg-forest-900/60 backdrop-blur-sm'}`} data-id="element-240" data-mp="jwgeeta7c9b">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8" data-id="element-241" data-mp="1pykpo76kse34">
        <a href="#inicio" className="font-display text-xl tracking-[0.22em] text-gold-400 md:text-[22px]" data-id="element-242" data-mp="1kzgifm37oqff">
          {site.empresa}
        </a>

        <nav aria-label="Principal" className="hidden items-center gap-8 lg:flex" data-id="element-243" data-mp="9qk8q1hs94u4">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] font-medium uppercase tracking-[0.12em] text-white transition-colors duration-150 ease-smooth hover:text-gold-400" data-id="element-244" data-mp="jmnle1a9glvb">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-245" data-mp="3s279ymzzlg41">
          <a href="#contacto" className="hidden rounded-full bg-gold px-6 py-3 text-[12px] font-semibold uppercase tracking-[0.14em] text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-gold-600 active:scale-[0.98] md:inline-flex" data-id="element-246" data-mp="3s2ysox8hjjcw">
            Quiero mi lote
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-11 w-11 place-items-center rounded-full border border-white/40 text-white lg:hidden" data-id="element-247" data-mp="39bz9kcno93rj">
            {open ? <XIcon size={20} data-id="element-248" data-mp="3b1ckc8u1bzwm" /> : <MenuIcon size={20} data-id="element-249" data-mp="3azrq6kbmuiza" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Móvil" className="border-t border-white/10 bg-forest-900/98 px-5 pb-6 pt-2 lg:hidden" data-id="element-250" data-mp="363b21q4fo4m7">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-white/10 py-3.5 text-sm font-medium uppercase tracking-[0.12em] text-white/85" data-id="element-251" data-mp="2de44atcszj20">
              {link.label}
            </a>)}
          <a href="#contacto" onClick={() => setOpen(false)} className="mt-5 block rounded-full bg-gold px-6 py-3.5 text-center text-[12px] font-semibold uppercase tracking-[0.14em] text-white" data-id="element-252" data-mp="7jb3ja6lbeub">
            Quiero mi lote hoy
          </a>
        </nav>}
    </header>;
}